import { ArrowUpRight } from "lucide-react";
import { STUDIOS } from "../data/site";
import { Reveal, Overline } from "./Reveal";
import { useI18n } from "../i18n/LanguageContext";

export const AirbnbBox = () => {
  const { t } = useI18n();
  return (
    <section data-testid="airbnb-section" className="max-w-7xl mx-auto px-6 md:px-10 pb-24 md:pb-32">
      <Reveal>
        <div className="border border-pine/20 bg-white/50 p-8 md:p-14">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
              <Overline>{t("airbnb.overline")}</Overline>
              <h2 className="font-serif text-3xl md:text-5xl tracking-tighter text-pine mt-4 leading-[1.05]">
                {t("airbnb.title")}
              </h2>
            </div>
            <p className="text-ink/50 text-sm max-w-xs">{t("airbnb.sub")}</p>
          </div>

          <div className="grid sm:grid-cols-2 gap-6">
            {STUDIOS.map((studio) => {
              const content = t(`studioData.${studio.slug}`);
              return (
                <a
                  key={studio.slug}
                  href={studio.airbnb}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`airbnb-card-${studio.slug}`}
                  className="group flex items-center gap-6 border border-pine/15 bg-cream p-5 hover:border-pine hover:-translate-y-1 transition-[border-color,transform] duration-300"
                >
                  <img
                    src={studio.image}
                    alt={studio.name}
                    loading="lazy"
                    className="w-24 h-24 md:w-28 md:h-28 object-cover shrink-0"
                  />
                  <div className="min-w-0">
                    <p className="text-xs uppercase tracking-[0.15em] text-wood-dark font-semibold">{studio.numeral}</p>
                    <h3 className="font-serif text-xl md:text-2xl text-pine tracking-tight truncate">{studio.name}</h3>
                    <p className="text-sm text-ink/50 italic font-serif mt-1">{content.tagline}</p>
                    <span className="mt-3 inline-flex items-center gap-2 text-sm font-semibold text-wood-dark group-hover:gap-3 transition-all duration-300">
                      {t("studio.ctaAirbnb")}
                      <ArrowUpRight aria-hidden className="w-4 h-4" />
                    </span>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
